import React from 'react'
import {Button, Modal} from 'react-bootstrap'
import {EmailContext} from '../context/EmailContext'

export default class EmailModal extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handleSend = this.handleSend.bind(this)
    this.state = {}
  }

  handleShow() {
    this.setState({show: true})
  }

  handleHide() {
    this.setState({show: false})
  }

  handleSend() {
    this.props.mail()
  }

  render() {
    return <div>
      <Modal
        {...this.props}
        show={this.state.show}
        onHide={this.handleHide}
        dialogClassName="custom-modal"
        backdrop={false}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            Wilt u de vragen aan medewerkers versturen?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p
            dangerouslySetInnerHTML={{__html: 'Let op: vragen die u heeft geselecteerd om te raadplegen, inclusief de eventuele extra vragen aan medewerkers, worden nu verstuurd. U kunt raadplegingen van een scan maar &eacute;&eacute;n keer versturen.'}}></p>
        </Modal.Body>
        <EmailContext.Consumer>
          {ctx => {
            const actionButton = () => {
              if (!ctx.state.isFeedbackSent) {
                ctx.isFeedbackAlreadySent()
              }
              return this.handleSend()
            }

            const cancelButton = () => {
              if (ctx.state.isFeedbackSent) {
                ctx.cancelFeedback()
              }
              return this.handleHide()
            }

            return (<Modal.Footer><Button onClick={actionButton} bsStyle="primary">Versturen</Button>
              <Button onClick={cancelButton}>Annuleren</Button>
            </Modal.Footer>)
          }}
        </EmailContext.Consumer>
      </Modal>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/EmailModal.js